import React from 'react';

import { dispatch } from '@rematch/core';
import { Form, Grid, Header, Button, List, Dropdown } from 'semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { withRouter } from 'react-router-dom';
import { debounce } from "lodash";
import Labels from './../../../../common/Labels'
import CommunityTree from './../../Drive/Tree/CommunityTree/CommunityTree';
import SimpleMappingTree from './../../Drive/Tree/CommunityTree/SimpleMappingTree';
import OrganizationTree from './../../Drive/Tree/OrganizationTree/OrganizationTree';
import LoadingComponent from "../../../../common/LoadingComponent";
import AssignCopyALLModal from "../../Drive/modals/AssignCopyALLModal";
import CreateInitiativeSteps from './Steps';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import _ from 'lodash';


let teamPathArray = [], communityDataMap = new Map();;
const processTeamData = function (teamNode, teamPath) {
    if(teamNode && teamNode.length>0){
        teamNode.forEach(function (subteam) {
            const updatedTeamPath = `${teamPath}-${subteam.label}`;
            if (subteam.nodes && subteam.nodes.length > 0) {
                processTeamData(subteam.nodes, updatedTeamPath)
            } else {
                teamPathArray.push(updatedTeamPath);
            }
        })
    }
}
class TeamMapping extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            teamStrings: [],
            orgStrings: [],
            showAssignCopyAllModal: false,
            teamLoader: false,
            teamId: null,
            isChecked: false,
            managers:[],
            members:[],
            childCommunities: [],
            updateFlag: false,
            selectedTeam:null
        };
        this.stopProcessing = this.stopProcessing.bind(this);
        this.startProcessing = this.startProcessing.bind(this);
        this.getTeam = this.getTeam.bind(this);
        // this.validate = this.validate.bind(this);
        // this.updateText = this.updateText.bind(this)
    }
    async componentWillMount() {
        dispatch.initiatives.dispatchOrgUnits([]);
        dispatch.app.setRouteParams(this.props.match.params)
        let selectedDataById = this.props.selectedDataById;
        let objValidation = Object.entries(selectedDataById).length === 0 && selectedDataById.constructor === Object


        await dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);


        if (this.props.selectedDataById && this.props.selectedDataById.teamId) {

            await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.stopProcessing, teamId: this.props.selectedDataById.teamId });
        }

        dispatch.initiatives.setTabName("teamMapping");
        if(this.props.selectedDataById.teamId){
            if (!this.props.teamList || this.props.teamList.length === 0) {
                let payload = {};
                payload.id = this.props.selectedOrganisation.id;
                payload.teamlist = true;
                dispatch.initiatives.getTeamsUnderManager(payload);
            }
            let teamManagers = [];
            let teamMembers = [];
            let childCommunities = [];
            let selectedTeam = this.props.nodes.find(n => n._id === this.props.selectedDataById.teamId);
            this.setState({selectedTeam: selectedTeam});
            if(selectedTeam && selectedTeam.members && selectedTeam.members.length>0){
                for(let user of selectedTeam.members) {
                    if(user.role == 'Manager') {
                        teamManagers.push(user);
                    } else {
                        teamMembers.push(user)
                    }
                }
                this.setState({managers: teamManagers});
                this.setState({members: teamMembers});
                for(let community of this.props.selectedDataById.communities){
                    await this.getChildCommunities(community, childCommunities, teamManagers, selectedTeam);
                }
                let selectedInitiative = this.props.selectedDataById;
                selectedInitiative.communities = this.props.selectedDataById.communities;
                selectedInitiative.teamId = selectedTeam._id;
                await dispatch.initiatives.setSelectedDataById(selectedInitiative);
                this.setState({'childCommunities': childCommunities});
                await dispatch.initiatives.setAccountableForCommunityProps({ childCommunities: childCommunities });
            }
        }        
    }
    componentDidMount() {
        this.setState({processing: true})
    }
    componentWillReceiveProps() {
        this.convertTeamsAndOrgsToStrings(this.props.nodes);
        if(!this.props.teamList && this.props.teamList.length === 0 ) {
            // this.setState({processing: true})
            let payload = {};
            payload.id = this.props.selectedOrganisation.id;
            payload.teamlist = true;
            dispatch.initiatives.getTeamsUnderManager(payload);
        }
    }
    convertTeamsAndOrgsToStrings() {
        teamPathArray = [], communityDataMap = new Map()
        this.props.selectedDataById && this.props.selectedDataById.communities && this.props.selectedDataById.communities.forEach(function (communityRecord) {
            const communityName = communityRecord.name;
            const communityKeys = [];
            communityRecord.communities.forEach(function (subCommunity) {
                const subCommunityName = subCommunity.name;
                communityKeys.push(`${communityName}-${subCommunityName}`);
            });
            if (communityKeys.length > 0) {
                communityDataMap.set(communityKeys[0], communityKeys);
            }
        });
        this.props.nodes.forEach(function (teamNode) {
            processTeamData(teamNode.nodes, teamNode.label)
        });
    }
    stopProcessing() {
        this.setState({ processing: false });
    }
    startProcessing() {
        this.setState({ processing: true });
    }
    setLoading = (flag) => {
        this.setState({ processing: flag });
    }
    next() {
        this.setState({ loader: true })
        setTimeout(() => {
            this.setState({ loader: false })
        }, 1000);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        this.nextClick()
        dispatch.initiatives.showResourecePane(null)
    }

    nextClick = debounce(async () => {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/configureActivity/' + this.props.match.params.initiativeId
        });
    }, 1000)

    backClick() {
        const history = this.props.history;
        // history.push({
        //     pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/addAdditionalInfo/' + this.props.match.params.initiativeId
        // });

        if (this.props.selectedDataById && this.props.selectedDataById.metaData && !_.isEmpty(this.props.selectedDataById.metaData)) {
            history.push({
                pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/addAdditionalInfo/' + this.props.match.params.initiativeId
            });
        } else {
            history.push({
                pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/basicInfo/' + this.props.match.params.initiativeId
            });
        }
        dispatch.initiatives.showResourecePane(null)
    }

    checkAllCommunitiesMapped() {
        if (this.props.selectedDataById && this.props.selectedDataById.communities) {
            for (let community of this.props.selectedDataById.communities) {
                for (let subCommunity of community.communities) {
                    if (!subCommunity.associatedTeam) {
                        return true;
                    }
                }
            }
        }

        return false
    }

    async autoMap(communities, teams) {
        let counter = new Set();

        this.setState({ processing: true });


        const autoMapTeams = async function (node, community, teamPath) {
            if (node.label === teamPath.split('-')[0]) {
                if (teamPath.split('-')[1]) {
                    node.nodes.forEach(team => {
                        if (team.label === teamPath.split('-')[1])
                            autoMapTeams(team, community, teamPath.substring(teamPath.indexOf('-') + 1, teamPath.length))
                    })

                }
                else {
                    for (let subCommunity of community.communities) {
                        for (let team of node.nodes) {
                            if (subCommunity.name === team.label && !subCommunity.associatedTeam) {
                                counter.add(subCommunity._id.toString());
                                dispatch.initiatives.mapCommunity({ communityId: subCommunity._id, teamId: team._id, accountable: team.members.filter(member => { return member.role === "Manager" })[0], initiativeId: subCommunity.initiativeId });

                            }
                        }
                    }
                }
            }

        }
        if (communities) {
            let teamData = this.props.nodes;
            for (var [key, value] of communityDataMap) {

                teamPathArray.forEach(async function (teamPath, index) {
                    if (teamPath.indexOf(key) > -1) {
                        let containsAllBranches = true;
                        const teamPathParent = teamPath.split(key)[0];
                        value.forEach(function (communityPath) {
                            const communityPathStr = `${teamPathParent}${communityPath}`;
                            let matchFoundForGivenBranch = false;
                            for (var index = 0; index < teamPathArray.length; index++) {
                                if (teamPathArray[index].indexOf(communityPathStr) > -1) {
                                    matchFoundForGivenBranch = true;
                                    break;
                                }
                            }
                            if (!matchFoundForGivenBranch) {
                                containsAllBranches = false;
                            }
                        })
                        if (containsAllBranches) {
                            for (let community of communities) {
                                if (community.name === key.split('-')[0]) {
                                    return teamData.forEach((node) => {
                                        if (node.label === teamPathArray[index].substring(0, teamPathArray[index].indexOf('-'))) {
                                            autoMapTeams(node, community, teamPath.substring(0, teamPath.lastIndexOf('-')))
                                            return;
                                        }
                                    })
                                }
                            }

                        }
                    }
                });
            }

        }
        dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, initiateAutoMap: true, stopProcessing: this.stopProcessing, teamId: this.props.selectedDataById.teamId });
        toastr.success('Message', [...counter].length + ' teams mapped.')
        this.setState({ processing: false })
    }
    openAssignCopyAllModal() {
        this.setState({ showAssignCopyAllModal: true })
    }
    closeAssignCopyAllModal = () => {
        this.setState({ showAssignCopyAllModal: false })
    }
    cancelEdit = () => {
        let message = <div className="confirmMessage">
            <h3>Cancel Editing</h3>
            <label>{this.props.selectedDataById.name}</label>
            <p>Are you sure that you want to Cancel editing this initiative?</p>
            <span >All the changes done until now will be lost.</span>
        </div>
        toastr.confirm(message, {
            okText: 'Cancel Editing',
            cancelText: 'Keep Editing',
            onOk: () => {
                dispatch.initiatives.cancelInitiativeEdit(this.props.selectedDataById);
            }
        });
    }
    getTeam() {
        const teamObj = this.props.teamList && this.props.teamList.filter((team) => {
            return team.value === this.props.selectedDataById.teamId
        })
        return teamObj ? teamObj && teamObj[0] && teamObj[0].text : '';
    }
    async handleTeam(values, data, teamId) {
        if((data && data.value) || teamId){
            let selectedTeam = null;
            if(!teamId){
                this.setState({ teamId: data.value })
                await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.stopProcessing, teamId: data.value });
                selectedTeam = this.props.nodes.find(n => n._id === data.value);
            } else {
                await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.stopProcessing, teamId });
                selectedTeam = this.props.nodes.find(n => n._id === teamId);
            }
            this.validate();
            let teamManagers = [];
            let teamMembers = [];
            let childCommunities = [];
            this.setState({selectedTeam: selectedTeam});
            for(let user of selectedTeam.members) {
                if(user.role == 'Manager') {
                    teamManagers.push(user);
                } else {
                    teamMembers.push(user)
                }
            }
            this.setState({managers: teamManagers});
            this.setState({members: teamMembers});
            if(this.props.selectedDataById.mapping && this.props.selectedDataById.mapping == 1 && this.props.selectedDataById.teamId){
                for(let community of this.props.selectedDataById.communities){
                    this.removeAccountablesFromCommunities(community, childCommunities);
                }
            } else {
                for(let community of this.props.selectedDataById.communities){
                    await this.getChildCommunities(community, childCommunities, teamManagers, selectedTeam);
                }
            }
            let selectedInitiative = this.props.selectedDataById;
            selectedInitiative.communities = this.props.selectedDataById.communities;
            selectedInitiative.teamId = selectedTeam._id;
            await dispatch.initiatives.setSelectedDataById(selectedInitiative);
            this.setState({'childCommunities': childCommunities});
            await dispatch.initiatives.setAccountableForCommunityProps({ childCommunities: childCommunities });
            this.setState({updateFlag: !this.state.updateFlag});
            let payload = {
                "_id": this.props.selectedDataById._id,
                "teamId": this.props.selectedDataById.teamId
            }
            dispatch.initiatives.updateInitiativeBySpecificFields(payload);
            if(this.props.selectedDataById.mapping == 0){
                await dispatch.initiatives.assignAllRolesToTeam({ communities: selectedInitiative.communities, team: selectedTeam._id, initiativeId: selectedInitiative._id });
            } else {
                if (this.state.teamId) {
                    await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.stopProcessing, teamId: this.state.teamId });
                }
            }
        }
    }
    async getChildCommunities(community, childCommunities, teamManagers, selectedTeam){
        if(community.parentCommunity){
            if(this.props.selectedDataById.mapping == 0 && !community.associatedTeam){
                community.associatedTeam = selectedTeam;
            }
            childCommunities.push(community);
            if(!community.accountable){
                community.accountable = teamManagers[0];
                await dispatch.initiatives.setAccountableForCommunity({ communityId: community._id, accountUserId: teamManagers[0]._id, option: 1 });
            }
        }
        if(community.communities.length>0){
            for(let childCommunity of community.communities){
                this.getChildCommunities(childCommunity, childCommunities, teamManagers, selectedTeam);
            }
        }
    }
    validate() {
        if (this.state.level === 'team' && (!this.state.teamId || this.state.teamId === this.props.selectedOrganisation.id)) {
            this.setState({ 'isDisabled': true });
        }
        else {
            this.setState({ 'isDisabled': false });
        }
    }
    async setExecutionMapping(e, data) {
        let payload = {};
        if(data.value=="0"){
            payload = {
                "_id": this.props.selectedDataById._id,
                "mapping": 0
            }
        } else {
            payload = {
                "_id": this.props.selectedDataById._id,
                "mapping": 1
            }
        }
        await dispatch.initiatives.updateInitiativeBySpecificFields(payload);
        let communities = this.props.selectedDataById.communities;
        if(data.value == "1"){
            for(let community of communities){
                this.removeAccountablesFromCommunities(community, communities);
            }
            let selectedInitiative = this.props.selectedDataById;
            selectedInitiative.communities = communities;
            await dispatch.initiatives.setSelectedDataById(selectedInitiative);
            if (this.props.selectedDataById.teamId) {
                await dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.stopProcessing, teamId: this.props.selectedDataById.teamId });
            }
        } else {
            if(this.props.selectedDataById.teamId != this.props.selectedOrganisation.id){
                this.handleTeam(null, null, this.props.selectedDataById.teamId)
            }
        }
        this.validate();
    }
    async removeAccountablesFromCommunities(community){
        if(community.accountable){
            delete community.accountable;
            delete community.associatedTeam;
            await dispatch.initiatives.removeMapping(community._id);
        }
        if(community.communities.length>0){
            for(let childCommunity of community.communities){
                this.removeAccountablesFromCommunities(childCommunity);
            }
        }
    }
    render() {
        const errorLabel = <div className="customErrorLabel" />;
        let isOrgLevel = this.props.selectedDataById && this.props.selectedDataById._id && this.props.selectedDataById.teamId && this.props.selectedDataById.teamId.toString() === this.props.selectedDataById.organizationId.toString()
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50;
        return (
            <div ref={this.parentRef} style={{ width: "100%", maxHeight: designerHeight ? designerHeight : 200, overflowY: "scroll" }}>
                <Grid className="containerBoxFullWidth">
                    <Grid.Row >
                        <BreadCrumbs {...this.props} />
                    </Grid.Row>
                    <Grid.Row >
                        <CreateInitiativeSteps {...this.props} setPage="teamMapping" />
                    </Grid.Row>
                    <Grid.Row >
                        <Grid className="w_100">
                            <Grid.Row
                                className="team_mapping"
                            >
                                <Grid.Column width={11}>
                                    <Form.Field>
                                        <Form.Group width={12} grouped style={{ 'marginTop': '8px' }}>
                                            <strong>Initiative Execution </strong>
                                            <Form.Group inline style={{ "marginTop": "12px", "display":"flex" }}>
                                                <Form.Radio
                                                    name='simple'
                                                    label='Simple Mapping'
                                                    value='0'
                                                    checked={this.props.selectedDataById.mapping === 0}
                                                    onChange={(event, data) => this.setExecutionMapping(event, data)}
                                                    style={{"marginRight":"24px"}}
                                                />
                                                <Form.Radio
                                                    name='advanced'
                                                    label='Advanced Mapping'
                                                    value='1'
                                                    checked={this.props.selectedDataById.mapping === 1}
                                                    onChange={(event, data) => this.setExecutionMapping(event, data)}
                                                />
                                            </Form.Group>
                                        </Form.Group>
                                    </Form.Field>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="team_mapping">
                            <Grid.Column width={11}>
                            {this.props.teamList.length > 1 ? <span></span> : <span className="clr-red">
                                    To create the initiative, please add a team to your workspace first.
                                </span>}

                                {/* // {(this.props.selectedMapping === 'workspace' && this.props.teamList.length === 1) ? 
                                //     <List verticalAlign='middle' className="w_100 display-block pad_10" style={{
                                //         borderRadius: "4px", border: "1px solid #D4B25E",
                                //         color: "#D4B25E",
                                //         background: "#FFF9DF"
                                //     }}>
                                //         <List.Item>
                                //             <List.Content floated='right'>
                                //                 <Button onClick={(e) => this.createTeam(e)} className="button-submit" >Create Team</Button>
                                //             </List.Content>
                                //             <List.Content style={{ lineHeight: "32px" }}>No teams available.</List.Content>
                                //         </List.Item>
                                //     </List> : <div></div>
                                // } */}

                                {(this.props.selectedDataById.teamId) || (!this.props.selectedDataById.teamId && this.props.selectedOrganisation.role === 'Manager') ?

                                    this.props.teamList && this.props.teamList.length !== 1 ?
                                        <Form.Group width={12} grouped style={{ 'marginTop': '8px', 'marginBottom': '8px' }}>
                                            <label>Search Team <span style={{ color: '#db2828' }}>*</span></label>
                                            <Dropdown
                                                name="singleSelectWithDefaultValue"
                                                placeholder="Search Team"
                                                search
                                                selection
                                                value={this.props.selectedDataById.teamId}
                                                required
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'Team is required',
                                                }}
                                                errorLabel={errorLabel}
                                                options={this.props.teamList}
                                                onChange={(values, value) => { this.handleTeam(values, value) }}
                                                style={{"marginLeft":"24px"}}
                                            />
                                        </Form.Group> :

                                        <List verticalAlign='middle' className="w_100 display-block pad_10" style={{
                                            borderRadius: "4px", border: "1px solid #D4B25E",
                                            color: "#D4B25E",
                                            background: "#FFF9DF"
                                        }}>
                                            <List.Item>
                                                <List.Content floated='right'>
                                                    <Button onClick={(e) => this.createTeam(e)} className="button-submit" >Create Team</Button>
                                                </List.Content>
                                                <List.Content style={{ lineHeight: "32px" }}>No teams available.</List.Content>
                                            </List.Item>
                                        </List>


                                    :
                                    this.props.selectedDataById.teamId && this.props.selectedDataById.teamId != this.props.selectedOrganisation.id ?
                                        <Labels
                                            name="Selected Team "
                                            text={this.getTeam()} />
                                        : ''
                                }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        {this.props.selectedDataById.teamId && this.props.selectedDataById.teamId.length>0 && this.props.selectedDataById.teamId != this.props.selectedOrganisation.id ? <Grid className="w_100 ">
                            <Grid.Row
                                className="team_mapping"
                                columns={2}
                                divided
                            >
                                <Grid.Column width={6} style={{ background: "#E3EAED" }}>
                                    <div className="teams" >
                                        <Header as='h4' >Required Roles</Header>
                                        {this.props.selectedDataById && this.props.selectedDataById.communities ?
                                            <CommunityTree
                                                user={this.props.user}
                                                parent={this.props.selectedPracticeFlowCommunity.parentCommunity}
                                                enableScrollNodeIntoView={false}
                                                {...this.props}
                                                getSelection={dispatch.initiatives.getSelectedCommunityAsync}
                                            /> : 'Loading...'}

                                    </div>
                                </Grid.Column>
                                <Grid.Column width={10} style={{ background: "#F4F8FB" }}>
                                    <div className="teams" >
                                        <Header className="teamMap" as='h4'>Team Mapping</Header>
                                        { this.props.selectedDataById.mapping == 0 && this.state.managers && this.state.managers.length>0 ?
                                            <SimpleMappingTree
                                                nodes={this.props.nodes}
                                                selectedOrganisation={
                                                    this.props.selectedOrganisation
                                                }
                                                childCommunities={this.state.childCommunities}
                                                startProcessing={this.startProcessing}
                                                stopProcessing={this.stopProcessing}
                                                setLoading={this.setLoading}
                                                managers={this.state.managers}
                                                members={this.state.members}
                                                selectedTeam={this.state.selectedTeam}
                                                {...this.props}
                                        />
                                        : this.props.nodes || this.props.nodes.length > 0 ?
                                            <OrganizationTree
                                                nodes={this.props.nodes}
                                                selectedOrganisation={
                                                    this.props.selectedOrganisation
                                                }
                                                startProcessing={this.startProcessing}
                                                stopProcessing={this.stopProcessing}
                                                setLoading={this.setLoading}
                                                {...this.props}
                                            /> : 'Loading...'}
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            {this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 4 ?
                                <Grid.Row>
                                    <Grid.Column width={8} className="pad_0">
                                        <div className="bottom_button_set">
                                            {this.props.selectedDataById.status !== 4 ? <Button
                                                onClick={() => this.backClick()}
                                                type="button"
                                                className="button-cancel">Previous</Button> :
                                                null}
                                            {this.props.selectedDataById.mapping == 1 ? <Button
                                                type="button"
                                                className="button-submit"
                                                onClick={() => this.openAssignCopyAllModal()}>Auto Assign</Button>:''}
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={8} className="pad_0">
                                    <div className="bottom_button_set" style={{ textAlign: 'right' }} >
                                            {this.props.selectedDataById.status === 4 && <Button
                                                type="button"
                                                className="button-cancel"
                                                onClick={() => this.cancelEdit()}>Cancel</Button>}
                                            <Button
                                                disabled={this.checkAllCommunitiesMapped() || this.props.nodes.length === 0}
                                                type="submit"
                                                id="next"
                                                className="button-submit"
                                                onClick={() => this.next()}
                                                loading={this.state.loader}
                                            >Next </Button>
                                        </div>
                                    </Grid.Column>
                                </Grid.Row> : ""}

                        </Grid>:""}
                    </Grid.Row>

                </Grid>
                <LoadingComponent active={this.state.processing} message={"Fetching role mapping"} />
                {this.props.selectedDataById.teamId && this.props.selectedDataById.teamId.length>0 && this.props.selectedDataById.teamId != this.props.selectedOrganisation.id && this.props.selectedDataById.mapping == 1 ? <AssignCopyALLModal
                    communities={this.props.selectedDataById.communities}
                    teams={this.props.nodes}
                    showAssignCopyAllModal={this.state.showAssignCopyAllModal}
                    closeModal={this.closeAssignCopyAllModal}
                    selectedOrganisation={this.props.selectedOrganisation}
                    initiativeId={this.props.selectedDataById._id}
                    startProcessing={this.startProcessing}
                    stopProcessing={this.stopProcessing}
                    teamId={this.props.selectedDataById.teamId}
                    initiative={this.props.selectedDataById}
                    isOrgLevel={isOrgLevel}
                    accountId={this.props.match.params.accountId}
                />:""}
            </div>
        );
    }
}

export default withRouter(TeamMapping);
